const common = {
  en: {
    cancel: 'Cancel',
    submit: 'Submit',
    next: 'Next',
    confirm: 'Confirm',
    back: 'Back',
    enter: 'Enter here',
    select: 'Choose one',
    ok: 'OK',
    ocard: 'Ocard E-membership',
    loading: 'Loading...',
    logout: 'Log out',
    mobileNumberIncorrect: 'Mobile number format incorrect',
    more: 'Load more',
    allSubBrand: 'All Brands',
    barcodeTimeOut: 'Barcode timeout',
    refresh: 'Refresh',
    close: 'Close',
    scan: 'Scan',
    notAllowedCameraError: 'No camera permission.',
    notFoundCameraError: 'Camera device not connected.',
    notSupportedNetworkError: 'Network environment not supported.',
    notReadableCameraError: 'Camera is used.',
    streamApiNotSupportedError: 'Browser not supported.',
    unableAccessCameraError: 'Unable to access camera.',
    unableScanError: 'Unable to scan, please enter the redeem password manually.',
    noData: 'No record',
  },
  'zh-Hant': {
    cancel: '取消',
    submit: '送出',
    next: '繼續',
    confirm: '確定',
    back: '返回',
    enter: '請輸入',
    select: '請選擇',
    ok: '好',
    ocard: 'Ocard 電子會員',
    loading: '載入中...',
    logout: '登出',
    mobileNumberIncorrect: '手機號碼格式錯誤',
    more: '查看更多',
    allSubBrand: '全品牌',
    barcodeTimeOut: '條碼已失效',
    refresh: '重新整理',
    close: '關閉',
    scan: '掃碼',
    notAllowedCameraError: '無相機權限',
    notFoundCameraError: '未連接相機設備',
    notSupportedNetworkError: '目前網路環境不支援',
    notReadableCameraError: '偵測到相機已被佔用',
    streamApiNotSupportedError: '目前瀏覽器不支援',
    unableAccessCameraError: '取用相機失敗',
    unableScanError: '無法進行掃碼，請使用手動輸入店家兌換密碼。',
    noData: '尚無資料',
  },
  vi: {
    cancel: 'Hủy',
    submit: 'Gửi đi',
    next: 'Tiếp tục',
    confirm: 'Chắc chắn',
    back: 'Trở về',
    enter: 'Vui lòng nhập',
    select: 'Vui lòng chọn',
    ok: 'OK',
    ocard: 'Hội viên điện tử Ocard',
    loading: 'Đang tải...',
    logout: 'Đăng xuất',
    mobileNumberIncorrect: 'Định dạng số máy di động bị lỗi',
    more: 'Xem thêm',
    allSubBrand: 'Toàn bộ thương hiệu',
    barcodeTimeOut: 'Mã vạch hết hạn',
    refresh: 'Làm mới lại',
    close: 'Tắt',
    scan: 'Quét mã',
    notAllowedCameraError: 'Không có quyền hạn máy ảnh',
    notFoundCameraError: 'Chưa kết nối với thiết bị máy ảnh',
    notSupportedNetworkError: 'Hiện tại không hỗ trợ môi trường mạng',
    notReadableCameraError: 'Phát hiện máy ảnh đã bị sử dụng',
    streamApiNotSupportedError: 'Hiện tại không hỗ trợ bộ trình duyệt',
    unableAccessCameraError: 'Truy cập máy ảnh không thành công',
    unableScanError: 'Không thể quét mã, vui lòng dùng máy di động nhập mã xác nhận của cửa hàng.',
    noData: 'Chưa có dữ liệu',
  },
  th: {
    cancel: 'ยกเลิก',
    submit: 'ส่ง',
    next: 'ต่อไป',
    confirm: 'ยืนยัน',
    back: 'กลับ',
    enter: 'กรุณากรอก',
    select: 'กรุณาเลือก',
    ok: 'ตกลง',
    ocard: 'E-membership ของ Ocard',
    loading: 'กำลังโหลด...',
    logout: 'ออกจากระบบ',
    mobileNumberIncorrect: 'รูปแบบเบอร์มือถือผิดพลาด',
    more: 'ดูเพิ่มเติม',
    allSubBrand: 'ทุกแบรนด์',
    barcodeTimeOut: 'บาร์โค้ดหมดอายุแล้ว',
    refresh: 'รีเฟรช',
    close: 'ปิด',
    scan: 'สแกน',
    notAllowedCameraError: 'จำกัดสิทธิ์เข้าถึงกล้อง',
    notFoundCameraError: 'ไม่ได้เชื่อมต่ออุปกรณ์กล้อง',
    notSupportedNetworkError: 'สภาพแวดล้อมเครือข่ายปัจจุบันไม่รองรับ',
    notReadableCameraError: 'ตรวจพบว่ากล้องถูกใช้งาน',
    streamApiNotSupportedError: 'เบราว์เซอร์ขณะนี้ไม่รองรับ',
    unableAccessCameraError: 'ไม่สามารถเข้าถึงกล้องได้',
    unableScanError: 'ไม่สามารถสแกนได้ โปรดกรอกรหัสยืนยันร้านค้าด้วยตนเอง',
    noData: 'ไม่มีข้อมูล',
  },
};

const entry = {
  en: {
    common: {
      login: 'Log in',
      signup: 'Sign up',
      mobileNumber: 'Mobile Number',
      terms:
        '“{brand}” provide services through Ocard. Ocard will not share your data to the third party except “{brand}”. By signing in, you give us permission to Ocard\'s <a href="/en/privacy" target="_blank">privacy policy</a> and agree with Ocard\'s <a href="/en/terms" target="_blank">terms and conditions</a>.',
      termsWithExternal:
        '“{brand}” provide services through Ocard. Ocard will not share your data to the third party except “{brand}”. By signing in, you give us permission to Ocard\'s <a href="/en/privacy" target="_blank">privacy policy</a>, and agree with  Ocard\'s <a href="/en/terms" target="_blank">terms and conditions</a> and “{brand}”\'s <a href="{external}" target="_blank">membership terms</a>',
      termsWithData:
        '“{brand}” provide services through Ocard, and we collect your personal information including {dataEn}. Ocard will not share your data to the third party except “{brand}”. By signing in, you give us permission to Ocard\'s <a href="/en/privacy" target="_blank">privacy policy</a> and agree with Ocard\'s <a href="/en/terms" target="_blank">terms and conditions</a>.',
      termsWithDataAndExternal:
        '“{brand}” provide services through Ocard, and we collect your personal information including {dataEn}. Ocard will not share your data to the third party except “{brand}”. By signing in, you give us permission to Ocard\'s <a href="/en/privacy" target="_blank">privacy policy</a>, and agree with Ocard\'s <a href="/en/terms" target="_blank">terms and conditions</a> and “{brand}”\'s <a href="{external}" target="_blank">membership terms</a>.',
      accept: 'Accept',
      mobileNumberIncorrect: 'Mobile number format incorrect',
      recaptchaTerms: 'Protected by reCAPTCHA<br>The Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.',
      recaptchaError: 'Verification failed, please try again',
      additionalInformation: 'Additional information',
    },
    welcome: {
      title: 'Log in to Ocard to manage your points and coupons at “{brand}”',
      titleOrder: 'Log in for online order at “{brand}”',
      titleOcardRewardsPartner: 'Log in for setting Ocard Rewards to {brand}',
      loginWithFb: 'Log in with Facebook',
      loginWithMobileNumber: 'Mobile number log in',
    },
    login: {
      title: 'Login',
      password: 'Password',
      forgotPassword: 'Forgot password',
      createAccount: 'Create account',
      fbFailed: 'Facebook log in failed, please try again',
      passwordEmpty: 'Please enter your password',
    },
    loginViaWhatsapp: {
      title: 'Log in to Ocard using WhatsApp to manage your points and coupons at “{brand}”',
      loginWithWhatsapp: 'Log in with WhatsApp',
      loginWithOther: 'Other log in methods',
      whatsappAccount: 'WhatsApp account',
      success: 'WhatsApp account log in successful',
    },
    lack: {
      title: '“{brand}” need you fill in full information',
      btn: 'Fill in full information',
    },
    invite: {
      title: 'Do you accept VIP invitation from “{brand}”?',
    },
    verify: {
      title: 'Mobile number login',
      desc: 'Please enter your mobile number to complete verification',
      code: 'Verification code',
      change: 'Change mobile number',
      resend: 'Resend code',
      help: 'Trouble getting verification code?',
      sent: 'Verification code has been sent to you by sms!',
      codeEmpty: 'Please enter the verification code',
      success: 'Verification successful!',
    },
    password: {
      title: 'Password setting',
      desc: 'Please set your password for “{number}”',
      input: 'Choose your password',
      confirm: 'Enter your password again',
      notMatch: 'Your password and confirmation password do not match',
      success: 'Password reset successful! Please log in with the new password',
    },
    profile: {
      title: 'Personal information',
      desc: 'Please fill in full information',
      facebook: 'Continue with Facebook',
      name: 'Full Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      birthday: 'Date of birth',
      pick: 'Pick',
      yearFormat: '{value}',
      monthFormat: '{value}',
      dayFormat: '{value}',
      nameEmpty: 'Please enter your full name',
      genderEmpty: 'Please select your gender',
      birthdayEmpty: 'Please enter your date of birth',
      customFieldsEmpty: 'Please enter {field}',
      customFieldsInvalid: 'Invalid {field}',
      customFieldsInvalidWithHelp: 'Invalid {field}',
      email: 'E-mail',
      location: 'City & District',
      locationCity: 'City & District',
      locationArea: 'Area',
      notice: 'Please make sure all data is correct.',
    },
    autopass: {
      title: 'I can not receive verification code',
      desc:
        '<div class="caption">Time differences for text sending.</div><p>It may take some time to receive text, if you did not receive text immediately, please wait patiently.</p><div class="caption">Your mobile number has set to block spam texts.</div><p>Text for verification code can be consider as spam text, so if your number turned on setting to block spam texts, you will not be able to receive it. You can contact your mobile company for further information and turn off this setting.</p><div class="caption">If you have tried everything above and it did not work, you can choose to verify it manually.</div><p>Please press the button below and write a text message, our system will fill in the message automatically, so please do not change the content and send it directly. System will verify your account manually within 30 minutes.</p><p>After system verified your account, you can skip the process for text verification using the same mobile number.</p>',
      iosBtn: 'iOS SMS',
      androidBtn: 'Android SMS',
      desc2:
        'P.S. You will have to cover the cost for sending texts, and if you pressed the button above and it did not fill in the text message for you, please copy and paste the paragraph below, and send it to this number: {number} manually.',
    },
  },
  'zh-Hant': {
    common: {
      login: '登入',
      signup: '註冊',
      mobileNumber: '手機號碼',
      terms:
        '「{brand}」透過 Ocard 提供服務，Ocard 不會將你的資料提供給除了「{brand}」以外任何第三方單位；登入即代表你同意 Ocard 的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>',
      termsWithExternal: '「{brand}」透過 Ocard 提供服務，Ocard 不會將你的資料提供給除了「{brand}」以外任何第三方單位；登入即代表你同意 Ocard 的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>，以及「{brand}」之<a href="{external}" target="_blank">會員條款</a>',
      termsWithData:
        '「{brand}」透過 Ocard 提供服務，將取得您的{data}等個人資料。Ocard 不會將你的資料提供給除了「{brand}」以外任何第三方單位；登入即代表你同意 Ocard 的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>',
      termsWithDataAndExternal:
        '「{brand}」透過 Ocard 提供服務，將取得您的{data}等個人資料。Ocard 不會將你的資料提供給除了「{brand}」以外任何第三方單位；登入即代表你同意 Ocard 的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>，以及「{brand}」之<a href="{external}" target="_blank">會員條款</a>',
      accept: '接受',
      mobileNumberIncorrect: '手機號碼格式錯誤',
      recaptchaTerms: '透過 reCAPTCHA 保護<br>繼續即代表你同意 Google <a href="https://policies.google.com/privacy" target="_blank">隱私權條款</a>與<a href="https://policies.google.com/terms" target="_blank">服務條款</a>',
      recaptchaError: '驗證失敗，請稍後再試',
      additionalInformation: '附加資料',
    },
    welcome: {
      title: '登入 Ocard 來管理你在「{brand}」的點數及優惠吧',
      titleOrder: '登入來使用「{brand}」Ocard 線上點功能',
      titleOcardRewardsPartner: '登入來將你的 Ocard Rewards 回饋獎勵設定為「{brand}」',
      loginWithFb: '使用 Facebook 登入',
      loginWithMobileNumber: '手機號碼登入',
    },
    login: {
      title: '帳號登入',
      password: '密碼',
      forgotPassword: '忘記密碼',
      createAccount: '註冊新帳號',
      fbFailed: 'Facebook 登入失敗，請重試',
      passwordEmpty: '請輸入密碼',
    },
    loginViaWhatsapp: {
      title: '使用 WhatsApp 登入 Ocard 來管理你在「{brand}」的點數及優惠吧',
      loginWithWhatsapp: '使用 WhatsApp 登入',
      loginWithOther: '其他登入方式',
      whatsappAccount: 'WhatsApp 帳號',
      success: 'WhatsApp 帳號登入成功',
    },
    lack: {
      title: '你的「{brand}」電子會員卡需要補充填寫部分個人資料',
      btn: '補充填寫',
    },
    invite: {
      title: '是否接受「{brand}」的會員邀請？',
    },
    verify: {
      title: '手機號碼登入',
      desc: '請輸入手機號碼並完成手機驗證',
      code: '認證碼',
      change: '修改手機號碼',
      resend: '重送認證碼',
      help: '收不到驗證碼？',
      sent: '已傳送認證碼簡訊！',
      codeEmpty: '請輸入認證碼',
      success: '驗證成功！',
    },
    password: {
      title: '密碼設定',
      desc: '請設定手機號碼「{number}」的登入密碼',
      input: '請輸入密碼',
      confirm: '請再次輸入密碼',
      notMatch: '兩次輸入的密碼不一致，請重新設定',
      success: '設定完成，請使用新的密碼進行登入！',
    },
    profile: {
      title: '個人資料填寫',
      desc: '請完成您的個人資料',
      facebook: '使用 Facebook 取得資料',
      name: '姓名',
      gender: '性別',
      male: '男性',
      female: '女性',
      birthday: '生日',
      pick: '選擇日期',
      yearFormat: '{value} 年',
      monthFormat: '{value} 月',
      dayFormat: '{value} 日',
      nameEmpty: '請輸入姓名',
      genderEmpty: '請選擇性別',
      birthdayEmpty: '請選擇生日',
      customFieldsEmpty: '請輸入{field}',
      customFieldsInvalid: '「{field}」填寫不正確',
      customFieldsInvalidWithHelp: '「{field}」填寫不正確：{help}。',
      email: 'E-mail',
      location: '居住地',
      locationCity: '居住縣市',
      locationArea: '鄉鎮市區',
      notice: '請確認您輸入的個人資料皆正確無誤。不正確的資料可能導致會員或使用優惠之權益受到損害。',
    },
    autopass: {
      title: '我一直無法收到簡訊',
      desc:
        '<div class="caption">簡訊發送的時間差</div><p>由於發送簡訊到接收簡訊需要一些時間，若您沒有立即收到簡訊，麻煩您靜待一段時間。</p><div class="caption">您的門號阻擋商業簡訊</div><p>由於認證碼簡訊被視為商業簡訊，如果您的門號有開啟阻擋商業簡訊功能，會造成無法接收認證碼簡訊的情形，您可以洽詢您的電信公司來取消此功能，各電信公司客服電話如下。</p><p>中華電信：手機直撥 800<br>台灣大哥大：手機直撥 188<br>遠傳：手機直撥 888<br>台灣之星：手機直撥 123</p><div class="caption">如果嘗試以上方法都無法解決，您可以使用手動開通</div><p>請按以下按鈕編寫簡訊，系統會直接幫您帶入簡訊內容，請直接送出，勿更改簡訊內容，系統將於 1～30 分鐘內手動替您開通帳號。</p><p>當系統為您開動帳號後，您下次輸入相同的手機號碼即可跳過簡訊驗證的步驟。</p>',
      iosBtn: 'iOS 簡訊',
      androidBtn: 'Android 簡訊',
      desc2:
        '※此簡訊之發送費用將由用戶自行負擔，若以上按鈕無法替您帶入簡訊文字，請全選並複製以下文字，並以手動方式編寫簡訊至以下號碼：{number}',
    },
  },
  vi: {
    common: {
      login: 'Đăng nhập',
      signup: 'Đăng ký',
      mobileNumber: 'Số điện thoại',
      terms:
        '“{brand}” cung cấp dịch vụ thông qua Ocard, Ocard sẽ không cung cấp thông tin của bạn cho bất kỳ bên thứ ba nào ngoại trừ “{brand}”; đăng nhập có nghĩa là bạn đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard.',
      termsWithExternal: '“{brand}” cung cấp dịch vụ thông qua Ocard, Ocard sẽ không cung cấp thông tin của bạn cho bất kỳ bên thứ ba nào ngoại trừ “{brand}”; đăng nhập có nghĩa là bạn đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard, cũng như <a href="{external}" target="_blank">điều khoản hội viên</a> “{brand}”.',
      termsWithData:
        '“{brand}” cung cấp dịch vụ thông qua Ocard, và sẽ có được thông tin cá nhân {data} của bạn. Ocard sẽ không cung cấp thông tin của bạn cho bất kỳ bên thứ ba nào ngoài “{brand}”; đăng nhập có nghĩa là bạn đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard.',
      termsWithDataAndExternal:
        '“{brand}” cung cấp dịch vụ thông qua Ocard, và sẽ có được thông tin cá nhân {data} của bạn. Ocard sẽ không cung cấp thông tin của bạn cho bất kỳ bên thứ ba nào ngoài “{brand}”; đăng nhập có nghĩa là bạn đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard, cũng như <a href="{external}" target="_blank">điều khoản hội viên</a> “{brand}”.',
      accept: 'Chấp nhận',
      mobileNumberIncorrect: 'Định dạng số máy di động bị lỗi',
      recaptchaTerms: 'Được bảo vệ bởi reCAPTCHA<br>Tiếp tục có nghĩa là bạn đồng ý với <a href="https://policies.google.com/privacy" target="_blank">Chính sách quyền riêng tư</a> và <a href="https://policies.google.com/terms" target="_blank">Điều khoản dịch vụ</a> của Google.',
      recaptchaError: 'Xác nhận không thành công, vui lòng thử lại',
      additionalInformation: 'Thông tin đính kèm',
    },
    welcome: {
      title: 'Đăng nhập Ocard để quản lý số điểm và ưu đãi của bạn trong “{brand}” nào',
      titleOrder: 'Đăng nhập để sử dụng chức năng gọi đồ trực tuyến của Ocard tại “{brand}”',
      titleOcardRewardsPartner: 'Đăng nhập để đặt phần thưởng Ocard Rewards thành “{brand}”',
      loginWithFb: 'Đăng nhập bằng Facebook',
      loginWithMobileNumber: 'Đăng nhập bằng số điện thoại',
    },
    login: {
      title: 'Đăng nhập số tài khoản',
      password: 'Mật khẩu',
      forgotPassword: 'Quên mật khẩu',
      createAccount: 'Đăng ký số tài khoản mới',
      fbFailed: 'Đăng nhập Facebook không thành công, vui lòng thử lại',
      passwordEmpty: 'Vui lòng nhập mật khẩu',
    },
    loginViaWhatsapp: {
      title: 'Sử dụng WhatsApp đăng nhập Ocard để quản lý số điểm và sưu đãi của bạn trên “{brand}”',
      loginWithWhatsapp: 'Đăng nhập bằng WhatsApp',
      loginWithOther: 'Phương thức đăng nhập khác',
      whatsappAccount: 'Số tài khoản WhatsApp',
      success: 'Đăng nhập số tài khoản WhatsApp thành công',
    },
    lack: {
      title: 'Thẻ hội viên điện tử “{brand}” của bạn cần bổ sung một số thông tin cá nhân',
      btn: 'Điền bổ sung',
    },
    invite: {
      title: 'Có chấp nhận lời mời hội viên của “{brand}” không?',
    },
    verify: {
      title: 'Đăng nhập bằng số điện thoại',
      desc: 'Vui lòng điền số điện thoại và tiến hành xác thực',
      code: 'Mã chứng nhận',
      change: 'Sửa đổi mã số máy di động',
      resend: 'Gửi lại mã chứng nhận',
      help: 'Không nhận được mã chứng nhận?',
      sent: 'Đã gửi tin nhắn mã chứng nhận!',
      codeEmpty: 'Vui lòng nhập mã chứng nhận',
      success: 'Nghiệm chứng thành công!',
    },
    password: {
      title: 'Thiết lập mật khẩu',
      desc: 'Vui lòng thiết lập mật khẩu đăng nhập của số máy di động “{number}”',
      input: 'Vui lòng nhập mật khẩu',
      confirm: 'Vui lòng nhập nhập lại mật khẩu',
      notMatch: 'Mật khẩu nhập hai lần khong khớp, vui lòng thiết lập lại',
      success: 'Hoàn thành thiết lập, vui lòng đăng nhập bằng mật khẩu mới!',
    },
    profile: {
      title: 'Điền thông tin cá nhân',
      desc: 'Vui lòng hoàn thành thông tin cá nhân',
      facebook: 'Tự động điền thông tin từ Facebook',
      name: 'Họ tên',
      gender: 'Giới tính',
      male: 'Nam',
      female: 'Nữ',
      birthday: 'Ngày sinh',
      pick: 'Chọn ngày',
      yearFormat: 'năm {value}',
      monthFormat: 'tháng {value}',
      dayFormat: 'ngày {value}',
      nameEmpty: 'Vui lòng nhập họ tên',
      genderEmpty: 'Vui lòng chọn giới tính',
      birthdayEmpty: 'Vui lòng chọn ngày sinh',
      customFieldsEmpty: 'Vui lòng nhập {field}',
      customFieldsInvalid: '“{field}” điền không đúng',
      customFieldsInvalidWithHelp: '“{field}” điền không đúng:{help}。',
      email: 'E-mail',
      location: 'Nơi cư trú',
      locationCity: 'Huyện/thành phố cư trú',
      locationArea: 'Khu vực xã, thị trấn, thành phố',
      notice: 'Vui lòng xác nhận rằng thông tin cá nhân bạn đã nhập là chính xác. Thông tin không chính xác có thể dẫn đến thiệt hại cho tư cách thành viên hoặc quyền sử dụng các ưu đãi.',
    },
    autopass: {
      title: 'Tôi vẫn không thể nhận được tin nhắn',
      desc: `
        <div class="caption">Mũi giờ gửi tin nhắn</div>
        <p>Vì phải mất một khoảng thời gian để gửi và nhận tin nhắn, nếu bạn không lập tức nhận được tin nhắn, vui lòng cho trong giây lát.</p>
        <div class="caption">Số điện thoại của bạn chặn tin nhắn thương mại</div>
        <p>Do tin nhắn mã chứng nhận bị coi là tin nhắn thương mại, nên nếu số điện thoại của bạn có mở chức năng chặn tin nhắn thương mại, thì sẽ không nhận được tin nhắn mã chứng nhận. Bạn có thể liên hệ với Công ty viễn thông của mình để hủy chức năng này, số điện thoại DVKH của các Công ty viễn thông như sau.</p>
        <div class="caption">Nếu bạn đã thử các phương pháp trên mà vẫn không thể giải quyết, bạn có thể kích hoạt bằng tay.</div>
        <p>Vui lòng nhấn nút bên dưới để soạn tin nhắn, hệ thống sẽ trực tiếp giúp bạn nhập nội dung tin nhắn. Vui lòng gửi trực tiếp, không được thay đổi nội dung tin nhắn. Hệ thống sẽ tự mở tài khoản cho bạn trong vòng 1 ~ 30 phút.</p>
        <p>Sau khi hệ thống kích hoạt tài khoản của bạn, bạn có thể bỏ qua bước nghiệm chứng tin nhắn bằng cách nhập số điện thoại di động tương tự vào lần tiếp theo.</p>
      `,
      iosBtn: 'Tin nhắn iOS',
      androidBtn: 'Tin nhắn Android',
      desc2:
        '※Chi phí gửi tin nhắn này sẽ do người dùng chịu. Nếu nút nhấn trên không thể đánh chữ cho tin nhắn, vui lòng chọn tất cả và sao chép văn tự, và soạn tin nhắn bằng tay vào số sau: {number}',
    },
  },
  th: {
    common: {
      login: 'เข้าสู่ระบบ',
      signup: 'ลงทะเบียน',
      mobileNumber: 'เบอร์มือถือ',
      terms:
        '“{brand}” ให้บริการผ่าน Ocard จะไม่ให้ข้อมูลของคุณแก่บุคคลที่สามอื่นใดนอกจาก “{brand}” การเข้าสู่ระบบ จะหมายถึงคุณยอมรับ<a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>และ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a>',
      termsWithExternal: '“{brand}” ให้บริการผ่าน Ocard จะไม่ให้ข้อมูลของคุณแก่บุคคลที่สามอื่นใดนอกจาก “{brand}” การเข้าสู่ระบบจะหมายถึงคุณยอมรับ<a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>และ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a> และเงื่อนไขสมาชิก “{brand}”',
      termsWithData:
        '“{brand}” ให้บริการผ่าน Ocard และจะได้รับ {data} และข้อมูลส่วนบุคคลอื่น ๆ ของคุณ Ocard จะไม่ให้ข้อมูลของคุณแก่บุคคลที่สามนอกจาก “{brand}” โดยการเข้าสู่ระบบ แสดงว่าคุณยอมรับ<a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>วและ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a>',
      termsWithDataAndExternal:
        '“{brand}” ให้บริการผ่าน Ocard และจะได้รับ {data} และข้อมูลส่วนบุคคลอื่น ๆ ของคุณ Ocard จะไม่ให้ข้อมูลของคุณแก่บุคคลที่สามนอกจาก “{brand}” โดยการเข้าสู่ระบบ คุณยอมรับ<a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>และ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a> รวมถึงข้อกำหนดการเป็นสมาชิกของ “{brand}”',
      accept: 'ยอมรับ',
      mobileNumberIncorrect: 'รูปแบบเบอร์มือถือผิดพลาด',
      recaptchaTerms: 'ได้รับการป้องกันโดย reCAPTCHA<br>การดำเนินการต่อ ถือว่าคุณยอมรับ<a href="https://policies.google.com/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a> และ<a href="https://policies.google.com/terms" target="_blank">ข้อกำหนดในการให้บริการ</a> ของ Google',
      recaptchaError: 'การตรวจสอบล้มเหลว โปรดลองใหม่อีกครั้งในภายหลัง',
      additionalInformation: 'ข้อมูลเพิ่มเติม',
    },
    welcome: {
      title: 'เข้าสู่ระบบ Ocard เพื่อจัดการคะแนนและส่วนลดสำหรับ “{brand}”',
      titleOrder: 'เข้าสู่ระบบเพื่อใช้ฟังก์ชั่นสั่งออนไลน์ Ocard ของ  “{brand}”',
      titleOcardRewardsPartner: 'ลงชื่อเข้าใช้เพื่อตั้งค่ารางวัล Ocard Rewards ของคุณเป็น “{brand}”',
      loginWithFb: 'เข้าสู่ระบบด้วย Facebook',
      loginWithMobileNumber: 'เข้าสู่ระบบด้วยเบอร์มือถือ',
    },
    login: {
      title: 'เข้าสู่ระบบบัญชี',
      password: 'รหัสผ่าน',
      forgotPassword: 'ลืมรหัสผ่าน',
      createAccount: 'ลงทะเบียนบัญชีใหม่',
      fbFailed: 'การเข้าสู่ระบบด้วย Facebook ล้มเหลว โปรดลองอีกครั้ง',
      passwordEmpty: 'กรุณากรอกรหัสผ่าน',
    },
    loginViaWhatsapp: {
      title: 'ใช้ WhatsApp เพื่อเข้าสู่ระบบ Ocard เพื่อจัดการคะแนนและส่วนลดของคุณสำหรับ “{brand}”',
      loginWithWhatsapp: 'ลงชื่อเข้าใช้ด้วย WhatsApp',
      loginWithOther: 'วิธีการเข้าสู่ระบบอื่น ๆ',
      whatsappAccount: 'บัญชี WhatsApp',
      success: 'เข้าสู่ระบบด้วย WhatsApp สำเร็จ',
    },
    lack: {
      title: 'บัต e-membership “{brand}” ของคุณต้องกรอกข้อมูลส่วนบุคคลเพิ่มเติม',
      btn: 'กรอกเพิ่มเติม',
    },
    invite: {
      title: 'คุณต้องการยอมรับคำเชิญเป็นสมาชิกจาก “{brand}” หรือไม่?',
    },
    verify: {
      title: 'เข้าสู่ระบบด้วยเบอร์มือถือ',
      desc: 'กรุณากรอกเบอร์มือถือของคุณและทำการยืนยันทางมือถือให้เสร็จสิ้น',
      code: 'รหัสยืนยัน',
      change: 'เปลี่ยนเบอร์มือถือ',
      resend: 'ส่งรหัสยืนยันอีกครั้ง',
      help: 'ไม่สามารถรับรหัสยืนยันได้?',
      sent: 'SMS รหัสยืนยันถูกส่งแล้ว!',
      codeEmpty: 'กรุณากรอกรหัสยืนยัน',
      success: 'ยืนยันสำเร็จ!',
    },
    password: {
      title: 'ตั้งรหัสผ่าน',
      desc: 'กรุณาตั้งรหัสผ่านเข้าสู่ระบบสำหรับเบอร์มือถือ “{number}“',
      input: 'กรุณากรอกรหัสผ่าน',
      confirm: 'กรุณากรอกรหัสผ่านอีกครั้ง',
      notMatch: 'รหัสผ่านที่กรอกสองครั้งไม่สอดคล้องกัน โปรดตั้งค่าใหม่',
      success: 'การตั้งค่าเสร็จสมบูรณ์ โปรดใช้รหัสผ่านใหม่เพื่อเข้าสู่ระบบ!',
    },
    profile: {
      title: 'กรอกข้อมูลส่วนบุคคล',
      desc: 'กรุณากรอกโปรไฟล์ของคุณ',
      facebook: 'รับข้อมูลผ่าน Facebook',
      name: 'ชื่อ',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      birthday: 'วันเกิด',
      pick: 'เลือกวันที่',
      yearFormat: 'ปี {value}',
      monthFormat: 'เดือน {value}',
      dayFormat: 'วันที่ {value}',
      nameEmpty: 'กรุณากรอกชื่อ',
      genderEmpty: 'กรุณาเลือกเพศ',
      birthdayEmpty: 'กรุณาเลือกวันเกิด',
      customFieldsEmpty: 'กรุณากรอก {field}',
      customFieldsInvalid: '“{field}“ กรอกไม่ถูกต้อง',
      customFieldsInvalidWithHelp: '“{field}“ กรอกไม่ถูกต้อง：{help}。',
      email: 'E-mail',
      location: 'ที่อยู่',
      locationCity: 'จังหวัดที่อยู่',
      locationArea: 'อำเภอและตำบล',
      notice: 'โปรดยืนยันว่าข้อมูลส่วนบุคคลที่คุณกรอกนั้นถูกต้อง ข้อมูลที่ไม่ถูกต้องอาจส่งผลให้เกิดความเสียหายต่อสมาชิกหรือสิทธิ์ในการใช้ส่วนลด',
    },
    autopass: {
      title: 'ฉันไม่สามารถรับข้อความได้',
      desc: `
        <div class="caption">เวลาส่ง SMS ต่างกัน</div>
        <p>เนื่องจากต้องใช้เวลาพอสมควรในการส่งข้อความ หากคุณไม่ได้รับข้อความทันที โปรดรอสักครู่</p>
        <div class="caption">เบอร์มือถือของคุณบล็อคข้อความเชิงพาณิชย์</div>
        <p>เนื่องจาก SMS รหัสยืนยันตัวตนถือเป็น SMS เชิงพาณิชย์ หากเบอร์มือถือของคุณมีฟังก์ชันในการบล็อค SMS เชิงพาณิชย์ จะส่งผลให้ไม่สามารถรับ SMS รหัสยืนยันตัวตนได้ คุณสามารถติดต่อบริษัทโทรคมนาคมเพื่อยกเลิกฟังก์ชันนี้ได้ เบอร์มือถือของบริษัทโทรคมนาคมแต่ละแห่งมีดังนี้</p>
        <div class="caption">หากไม่สามารถแก้ไขปัญหาได้หลังจากลองวิธีการข้างต้นแล้ว คุณสามารถใช้การเปิดใช้งานด้วยตนเองได้</div>
        <p>กรุณากดปุ่มด้านล่างเพื่อเขียนข้อความ และระบบจะช่วยคุณกรอกเนื้อหาข้อความกรุณาส่งทันทีและอย่าเปลี่ยนเนื้อหาข้อความ ระบบจะเปิดบัญชีให้คุณด้วยตนเองภายใน 1-30 นาที</p>
        <p>หลังจากที่ระบบเปิดใช้งานบัญชีของคุณแล้ว คุณสามารถข้ามขั้นตอนการยืนยันทาง SMS ได้โดยกรอกเบอร์มือถือเดิมในครั้งต่อไป</p>
      `,
      iosBtn: 'iOS SMS',
      androidBtn: 'Android SMS',
      desc2:
        '※ค่าใช้จ่ายในการส่งข้อความนี้จะต้องรับผิดชอบโดยผู้ใช้ หากปุ่มด้านบนไม่สามารถกรอกข้อความให้คุณได้ โปรดเลือกทั้งหมดและคัดลอกข้อความต่อไปนี้ และเขียนข้อความด้วยตนเองไปยังหมายเลขต่อไปนี้: {number}',
    },
  },
};

const index = {
  en: {
    barcode: 'Barcode',
    soundcode: 'Waves',
    connectEinvoice: 'Connect E-invoice cellphone barcode',
    Einvoice: 'E-invoice cellphone barcode',
    EinvoicePlaceholder: 'Please enter cellphone barcode',
    cellphoneBarcodeEmpty: 'Please enter cellphone barcode',
    invalidCellphoneBarcodeEmpty: 'Invalid cellphone barcode',
    cellphoneBarcodeSuccess: 'Updated successfully',
    customerJourney: 'Transactions',
    navigationMenu: 'Menu',
  },
  'zh-Hant': {
    barcode: '條碼',
    soundcode: '感應',
    connectEinvoice: '綁定電子發票手機條碼載具',
    Einvoice: '手機條碼載具',
    EinvoicePlaceholder: '請輸入 / 開頭之手機條碼載具',
    cellphoneBarcodeEmpty: '請輸入手機條碼',
    invalidCellphoneBarcodeEmpty: '手機條碼格式不正確',
    cellphoneBarcodeSuccess: '設定成功，請重新出示會員條碼給服務人員掃描',
    customerJourney: '消費歷程',
    navigationMenu: '功能選單',
  },
  vi: {
    barcode: 'Mã vạch',
    soundcode: 'Cảm ứng',
    connectEinvoice: 'Ràng buộc công cụ tải mã vạch máy di động cho hóa đơn điện tử',
    Einvoice: 'Công cụ tải mã vạch máy di động',
    EinvoicePlaceholder: 'Vui lòng nhập công cụ tải mã vạch máy di động mở đầu là /',
    cellphoneBarcodeEmpty: 'Vui lòng nhập mã vạch máy di động',
    invalidCellphoneBarcodeEmpty: 'Định dáng mã vạch máy di động không chính xác',
    cellphoneBarcodeSuccess: 'Thiết lập thành công, vui lòng xuất trình lại mã vạch hội viên cho nhân viên phục vụ quét mã',
    customerJourney: 'Lịch sử tiêu dùng',
    navigationMenu: 'Menu chức năng',
  },
  th: {
    barcode: 'บาร์โค้ด',
    soundcode: 'เซนเซอร์',
    connectEinvoice: 'ผูกผู้ให้บริการ E-invoice บาร์โค้ดมือถือ',
    Einvoice: 'E-invoice บาร์โค้ดมือถือ',
    EinvoicePlaceholder: 'กรุณากรอก E-invoice บาร์โค้ดมือถือที่ขึ้นต้นด้วย /',
    cellphoneBarcodeEmpty: 'กรุณากรอกบาร์โค้ดมือถือ',
    invalidCellphoneBarcodeEmpty: 'รูปแบบบาร์โค้ดมือถือไม่ถูกต้อง',
    cellphoneBarcodeSuccess: 'การตั้งค่าสำเร็จ กรุณาแสดงบาร์โค้ดสมาชิกให้เจ้าหน้าที่บริการสแกนอีกครั้ง',
    customerJourney: 'ประวัติการใช้จ่าย',
    navigationMenu: 'เมนูฟังก์ชัน',
  },
};

const barcode = {
  en: {
    vipBarcode: 'VIP Barcode',
    desc: 'Barcodes may become invalid when sharing via photo or screenshot.',
    redeemCouponViaBarcode: 'Redeem via barcode',
    redeemRewardViaBarcode: 'Redeem via barcode',
    barcodeTimer: 'Barcode timer',
  },
  'zh-Hant': {
    vipBarcode: '會員條碼',
    desc: '提醒您，以翻拍、截圖方式傳輸至其他設備，可能導致條碼無效。',
    redeemCouponViaBarcode: '條碼兌換',
    redeemRewardViaBarcode: '條碼兌換',
    barcodeTimer: '條碼時效',
  },
  vi: {
    vipBarcode: 'Mã vạch hội viên',
    desc: 'Xin nhắc, gửi đến thiết bị khác bằng phương thức chụp lại, cắt hình, thì mã vạch sẽ không có hiệu lực.',
    redeemCouponViaBarcode: 'Xóa sổ bằng mã vạch',
    redeemRewardViaBarcode: 'Đổi thưởng bằng mã vạch',
    barcodeTimer: 'Bộ hẹn giờ mã vạch',
  },
  th: {
    vipBarcode: 'บาร์โค้ดสมาชิก',
    desc: 'โปรดทราบว่าการคัดลอกหรือการถ่ายภาพหน้าจอเพื่อถ่ายโอนไปยังอุปกรณ์อื่นอาจทำให้บาร์โค้ดไม่ถูกต้อง',
    redeemCouponViaBarcode: 'บาร์โค้ดคืน',
    redeemRewardViaBarcode: 'บาร์โค้ดแลก',
    barcodeTimer: 'อายุบาร์โค้ด',
  },
};

const ultrasound = {
  en: {
    title: 'My Sound Code',
    desc:
      'Please adjust the volume to maximum in order to enhance the accuracy',
    play: 'Tap to play',
  },
  'zh-Hant': {
    title: '音波認證',
    desc: '請將音量調整為最大以增加識別準確度',
    play: '輕觸播放',
  },
  vi: {
    title: 'Chứng nhận âm thành',
    desc: 'Vui lòng điều chỉnh âm lượng lên mức cao nhất để nhận dạng chính xác',
    play: 'Nhấp vào để mở',
  },
  th: {
    title: 'การรับรองด้วยเสียง',
    desc: 'โปรดปรับระดับเสียงให้สูงสุดเพื่อเพิ่มความแม่นยำในการจดจำ',
    play: 'แตะเพื่อเล่น',
  },
};

const tab = {
  en: {
    points: 'Point | Point | Points',
    coupons: 'Coupon | Coupon | Coupons',
    brand: 'About',
    programs: 'Programs',
  },
  'zh-Hant': {
    points: '點數',
    coupons: '禮物券',
    brand: '店家資訊',
    programs: '活動',
  },
  vi: {
    points: 'Số điểm',
    coupons: 'Phiếu quà',
    brand: 'Về chúng tôi',
    programs: 'Hoạt động',
  },
  th: {
    points: 'คะแนน',
    coupons: 'บัตรกำนัล',
    brand: 'ข้อมูลร้านค้า',
    programs: 'กิจกรรม',
  },
};

const points = {
  en: {
    empty: 'No activity',
    programs: 'Reward Programs',
    limited: 'Limited-Time Points',
    expire: 'Expire in',
    progress: 'Progress',
    archive: 'Archive',
    claim: 'Claim',
    received: 'Received',
    toUnlock: '{point} Pt to unlock| {point} Pts to unlock',
    points: 'Pt | Pts',
    dollars: 'Dollar | Dollar | Dollars',
    rewards: 'Rewards',
    history: 'Balance History',
    historyEmpty: 'No record',
    pointExpire: 'Valid till',
    disabled: 'Please ask for assistance',
    remain: 'Remaing',
  },
  'zh-Hant': {
    empty: '目前沒有集點活動',
    programs: '點數活動',
    limited: '即將到期點數',
    progress: '進度詳情',
    archive: '完成度',
    expire: '到期日',
    rewards: '點數兌換',
    points: '點',
    dollars: '元',
    claim: '領取',
    received: '已領取',
    toUnlock: '累積 {point} 點解鎖',
    history: '點數歷史',
    historyEmpty: '尚無紀錄',
    pointExpire: '使用期限',
    disabled: '請洽服務人員',
    remain: '剩餘數量',
  },
  vi: {
    empty: 'Hiện tại không có hoạt động tích điểm',
    programs: 'Hoạt động tích điểm',
    limited: 'Số điểm sắp hết hạn',
    progress: 'Chi tiết tiến độ',
    archive: 'Mức độ hoàn thành',
    expire: 'Ngày hết hạn',
    rewards: 'Đổi số điểm',
    points: 'Điểm',
    dollars: 'tệ',
    claim: 'Lĩnh nhận',
    received: 'Đã lĩnh nhận',
    toUnlock: 'Tích lũy {point} điểm sẽ mở khóa',
    history: 'Lịch sử tích điểm',
    historyEmpty: 'Không có ghi chép',
    pointExpire: 'Thời hạn sử dụng',
    disabled: 'Vui lòng yêu cầu sự hỗ trợ',
    remain: 'Số lượng còn lại',
  },
  th: {
    empty: 'ขณะนี้ยังไม่มีกิจกรรมสะสมคะแนน',
    programs: 'ขณะนี้ยังไม่มีกิจกรรมสะสมคะแนน',
    limited: 'คะแนนกำลังจะหมดอายุ',
    progress: 'รายละเอียดความคืบหน้า',
    archive: 'ความสมบูรณ์',
    expire: 'วันหมดอายุ',
    rewards: 'แลกคะแนน',
    points: 'แลกคะแนน',
    dollars: 'บาท',
    claim: 'รับ',
    received: 'รับแล้ว',
    toUnlock: 'สะสม {point} คะแนนเพื่อปลดล็อค',
    history: 'ประวัติคะแนน',
    historyEmpty: 'ยังไม่มีบันทึก',
    pointExpire: 'ระยะเวลาการใช้งาน',
    disabled: 'กรุณาขอความช่วยเหลือ',
    remain: 'จำนวนคงเหลือ',
  },
};

const reward = {
  en: {
    title: 'Reward',
    content: 'Instruction',
    remain: '{count} left',
    redeem: 'Redeem',
    need: 'Need {points} point | Need {points} points',
    needMore: 'Need {points} more point | Need {points} more points',
    lack: 'Not enough points left',
    amount: 'Please enter the amount',
    amountPlaceholder: '1',
    confirm1:
      'This operation cannot be undone. Are you sure you are going to use {points} point | Are you sure you are going to use {points} points',
    confirm2:
      'This operation cannot be undone. Are you sure you are going to use {points} point | Are you sure you are going to use {points} points',
    confirm3: 'to redeem {amount} set | to redeem {amount} sets',
    confirm4: 'of {reward} reward?',
    storePIN: 'To Redeem "{reward} × {amount}", Please pass your device to the staff for entring redeem password.',
    lessAmount1: 'Redeem {amount} set | Redeem {amount} sets',
    lessAmount2:
    'of {reward} reward need {points} point in total. | of {reward} reward need {points} points in total.',
    lessAmount3:
    'You have only {userPoints} point left, please enter a vaild amount. | You have only {userPoints} points left, please enter a vaild amount.',
    amountIncorrect: 'Incorrect amount',
    enterStorePIN: 'Please ask the staff to enter the store redeem password.',
    enterSpend: 'Please enter the payment amount.',
    enterPoints: 'Please enter the issued points.',
  },
  'zh-Hant': {
    title: '兌換內容',
    content: '說明',
    remain: '剩餘兌換數量 {count} 份',
    redeem: '兌換',
    need: '需要 {points} 點',
    needMore: '點數不足 {points} 點',
    lack: '您的剩餘點數不足夠',
    amount: '請輸入兌換份數',
    amountPlaceholder: '1 份',
    confirm1: '提醒您，點數兌換後即不可回復，點數兌換需由服務人員操作。\n是否使用 {points} 點',
    confirm2: '提醒您，點數兌換後即不可回復。\n是否使用 {points} 點',
    confirm3: '兌換 {amount} 份',
    confirm4: '「{reward}」？',
    storePIN: '已選擇兌換「{reward} × {amount}」，請交由服務人員輸入店家兌換密碼。',
    lessAmount1: '兌換 {amount} 份',
    lessAmount2: '「{reward}」需要共計 {points} 點，',
    lessAmount3: '您目前只剩餘 {userPoints} 點，請重新選擇數量。',
    amountIncorrect: '請輸入正確的數量',
    enterStorePIN: '請交由服務人員輸入店家兌換密碼',
    enterSpend: '請輸入消費金額',
    enterPoints: '請輸入發送點數',
  },
  vi: {
    title: 'Nội dung đổi quà',
    content: 'Giải thích',
    remain: 'Số lượng đổi quà còn lại {count} phần',
    redeem: 'Đổi quà',
    need: 'Có muốn {points} điểm',
    needMore: 'Số điểm không đủ {points} điểm',
    lack: 'Số điểm còn lại không đủ',
    amount: 'Vui lòng nhập số phần quà đổi',
    amountPlaceholder: '1',
    confirm1: 'Xin nhắc, sau khi đổi số điểm thì sẽ không khôi phục lại, và đổi số điểm phải do nhân viên phục vụ thực hiện. \nCó sử dụng {points} điểm không',
    confirm2: 'Xin nhắc, sau khi đổi số điểm thì sẽ không khôi phục lại. \nCó sử dụng {points} điểm không',
    confirm3: 'Đổ {amount} phần',
    confirm4: '“{reward}”？',
    storePIN: 'Đã chọn đổi {reward} × {amount}, vui lòng giao cho nhân viên phục vụ nhập mã xóa sổ của cửa hàng.',
    lessAmount1: 'Đổ {amount} phần',
    lessAmount2: '「“{reward}” phải có tổng cộng {points} điểm, ',
    lessAmount3: 'Hiện tại bạn chỉ còn lại {userPoints} điểm, vui lòng chọn lại số lượng.',
    amountIncorrect: 'Vui lòng nhập số lượng chính xác',
    enterStorePIN: 'Vui lòng giao cho nhân viên phục vụ nhập mã xóa sổ của cửa hàng.',
    enterSpend: 'Vui lòng nhập số tiền thanh toán',
    enterPoints: 'Vui lòng nhập số điểm gửi đi',
  },
  th: {
    title: 'เนื้อหาการแลก',
    content: 'อธิบาย',
    remain: 'จำนวนการแลกคงเหลือ {count}',
    redeem: 'แลกเปลี่ยน',
    need: 'ต้องใช้ {points} คะแนน',
    needMore: 'คะแนนไม่เพียงพอ {points} คะแนน',
    lack: 'คุณมีคะแนนเหลือไม่เพียงพอ',
    amount: 'กรุณากรอกจำนวนแลกรางวัล',
    amountPlaceholder: '1',
    confirm1: 'โปรดทราบว่าเมื่อแลกคะแนนแล้วไม่สามารถเรียกคืนได้ และการแลกคะแนนจะต้องดำเนินการโดยเจ้าหน้าที่บริการ \nต้องการใช้ {points} คะแนนหรือไม่',
    confirm2: 'โปรดทราบว่าเมื่อแลกคะแนนแล้วไม่สามารถเรียกคืนได้ \nต้องการใช้ {points} คะแนนหรือไม่',
    confirm3: 'แลก {amount}',
    confirm4: '「{reward}」？',
    storePIN: 'คุณได้เลือกที่จะแลก {reward} × {amount} โปรดให้เจ้าหน้าที่บริการกรอกรหัสยืนยันร้านค้า',
    lessAmount1: 'แลก {amount}',
    lessAmount2: '{reward} ต้องใช้คะแนนรวมทั้งหมด {points} คะแนน',
    lessAmount3: 'คุณเหลือเพียง {userPoints} โปรดเลือกจำนวนใหม่',
    amountIncorrect: 'กรุณากรอกจำนวนที่ถูกต้อง',
    enterStorePIN: 'กรุณาขอให้เจ้าหน้าที่บริการกรอกรหัสยืนยันร้านค้า',
    enterSpend: 'กรุณากรอกยอดการใช้จ่าย',
    enterPoints: 'กรุณากรอกคะแนนที่ส่ง',
  },
};

const coupons = {
  en: {
    title: 'Coupon',
    coupons: 'Coupons',
    empty: 'No coupon available',
    used: 'Used',
    expireOn: 'Expired on {date}',
    expired: 'Expire date {date}',
    usedOn: 'Used at',
    instruction: 'Instruction',
    how: 'Policy',
    receivedOn: 'Received on',
    serialNumber: 'Serial Number',
    redeem: 'Redeem',
    multiRedeem: 'Batch Redeem',
    confirm:
      'This operation cannot be undone.\nAre you sure you want to redeem this coupon?',
    confirm2:
      'This operation cannot be undone.\nAre you sure you want to redeem these coupons?',
    storePIN: 'To Redeem "{coupon}", Please pass your device to the staff for entering store Redeem Password.',
    send: 'Gift',
    sendDesc:
      "Attention! You cannot use this coupon after you send it. And please don't send it to more than one person, because it can only use for one time.",
    viaMobileNumber: 'Mobile',
    viaMobileNumberDesc: 'Bind to a mobile',
    viaSNS: 'SNS',
    viaSNSDesc: 'Create a share URL',
    mobileShareConfirm:
      'Are you sure you want to send "{coupon}" to mobile number {mobile}? You cannot use this coupon after you send it.',
    shareTextCopied: 'Share text copied!',
    line: 'LINE',
    messenger: 'Messenger',
    copy: 'Copy',
    sms: 'SMS',
    other: 'other',
    amount: 'Please enter the amount',
    amountPlaceholder: '1',
    shareHistory: 'Shared',
    expiryClosest: 'Expiry: Closest',
    expiryLatest: 'Expiry: Latest',
    receiveClosest: 'Receive: Closest',
    receiveLatest: 'Receive: Earliest',
  },
  'zh-Hant': {
    title: '禮物券',
    coupons: '禮物券',
    empty: '目前沒有禮物券',
    used: '已使用',
    expireOn: '已於 {date} 到期',
    expired: '{date} 到期',
    usedOn: '使用日期',
    instruction: '優惠內容',
    how: '使用方法',
    receivedOn: '接收日期',
    serialNumber: '序號',
    redeem: '使用',
    multiRedeem: '使用多張',
    confirm: '提醒您，禮物券一經使用後即不可回復，使用禮物券需由服務人員操作。\n是否使用「{coupon}」？',
    confirm2: '提醒您，禮物券一經使用後即不可回復，使用禮物券需由服務人員操作。\n是否使用 {amount} 張「{coupon}」？',
    storePIN: '已選擇使用「{coupon}」，請交由服務人員輸入店家兌換密碼。',
    send: '轉贈',
    sendDesc:
      '提醒您，禮物券送出後，您將無法使用。\n請注意，每份禮物僅限一人領取一次，請勿傳送給多個朋友。',
    viaMobileNumber: '手機號碼',
    viaMobileNumberDesc: '歸戶至手機號碼',
    viaSNS: '社群轉贈',
    viaSNSDesc: '產生分享連結',
    mobileShareConfirm:
      '是否將「{coupon}」轉送至手機號碼 {mobile}？\n提醒您，禮物券送出後，您將無法使用。',
    shareTextCopied: '文字已複製！',
    line: 'LINE',
    messenger: 'Messenger',
    copy: '複製',
    sms: '傳送簡訊',
    other: '其他分享',
    amount: '請輸入使用張數',
    amountPlaceholder: '1 張',
    shareHistory: '轉贈紀錄',
    expiryClosest: '到期日期：最近在前',
    expiryLatest: '到期日期：最晚在前',
    receiveClosest: '接收日期：最近在前',
    receiveLatest: '接收日期：最早在前',
  },
  vi: {
    title: 'Phiếu quà',
    coupons: 'Phiếu quà',
    empty: 'Hiện tại không có phiếu quà',
    used: 'Đã sử dụng',
    expireOn: 'Đã hết hạn vào {date}',
    expired: '{date} hết hạn',
    usedOn: 'Ngày sử dụng',
    instruction: 'Nội dung ưu đãi',
    how: 'Phương pháp sử dụng',
    receivedOn: 'Ngày chấp nhận',
    serialNumber: 'Thứ tự',
    redeem: 'Sử dụng',
    multiRedeem: 'Sử dụng nhiều phiếu',
    confirm: 'Xin nhắc, phiếu quà tặng một khi đã sử dụng, thì không thể được khôi phục, sử dụng phiếu quà tặng phải do nhân viên phục vụ thực hiện. Có muốn sử dụng “{coupon}” không?',
    confirm2: 'Xin nhắc, phiếu quà tặng một khi đã sử dụng, thì không thể được khôi phục, sử dụng phiếu quà tặng phải do nhân viên phục vụ thực hiện. Có muốn sử dụng {amount} phiếu “{coupon}” không?',
    storePIN: 'Đã chọn sử dụng “{coupon}”, vui lòng giao cho nhân viên phục vụ nhập mã xóa sổ của cửa hàng.',
    send: 'Chuyển tặng',
    sendDesc:
      'Xin nhắc, phiếu quà tặng sau khi gửi đi, bạn sẽ không thể sử dụng. Xin lưu ý, mỗi một phần quà chỉ được một người lĩnh nhận một lần, không dược chuyển tặng cho nhiều bạn bè.',
    viaMobileNumber: 'Số điện thoại',
    viaMobileNumberDesc: 'Liên kết với số máy di động',
    viaSNS: 'Chuyện tặng nhóm',
    viaSNSDesc: 'Tạo liên kết chia sẻ',
    mobileShareConfirm:
      'Có muốn chuyển tặng “{coupon}” tới số máy di động {mobile} không? Xin nhắc, phiếu quà tặng sau khi gửi đi, bạn sẽ không thể sử dụng.',
    shareTextCopied: 'Đã copy chữ!',
    line: 'LINE',
    messenger: 'Messenger',
    copy: 'Copy',
    sms: 'Gửi tin nhắn',
    other: 'Chia sẻ khác',
    amount: 'Vui lòng nhập số phiếu sử dụng',
    amountPlaceholder: '1 phiếu',
    shareHistory: 'Ghi chép chuyển tặng',
    expiryClosest: 'Ngày hết hạn: Gần nhất',
    expiryLatest: 'Ngày hết hạn: Mới nhất',
    receiveClosest: 'Ngày nhận: Gần nhất',
    receiveLatest: 'Ngày nhận: Mới nhất',
  },
  th: {
    title: 'บัตรกำนัล',
    coupons: 'บัตรกำนัล',
    empty: 'ขณะนี้ไม่มีบัตรกำนัล',
    used: 'ใช้แล้ว',
    expireOn: 'หมดอายุวันที่ {date}',
    expired: '{date} หมดอายุ',
    usedOn: 'วันที่ใช้งาน',
    instruction: 'เนื้อหาส่วนลด',
    how: 'วิธีใช้',
    receivedOn: 'วันที่ได้รับ',
    serialNumber: 'เลขซีเรียล',
    redeem: 'ใช้',
    multiRedeem: 'ใช้หลายใบ',
    confirm: 'โปรดทราบว่าบัตรกำนัลเมื่อใช้แล้วไม่สามารถเรียกคืนได้ และการใช้บัตรกำนัลจะต้องดำเนินการโดยเจ้าหน้าที่บริการ ต้องการใช้ “{coupon}” หรือไม่?',
    confirm2: 'โปรดทราบว่าบัตรกำนัลเมื่อใช้แล้วไม่สามารถเรียกคืนได้  และการใช้บัตรกำนัลจะต้องดำเนินการโดยเจ้าหน้าที่บริการ ใช้ “{coupon}” {amount} ใบ?',
    storePIN: 'คุณได้เลือกใช้ “{coupon}” กรุณาให้เจ้าหน้าที่บริการกรอกรหัสยืนยันร้านค้า',
    send: 'ส่งของขวัญ',
    sendDesc:
      'โปรดทราบว่าคุณจะไม่สามารถใช้บัตรกำนัลได้หลังจากที่ส่งไปแล้ว โปรดทราบว่าของขวัญแต่ละชิ้นสามารถรับได้เพียงคนเดียวเท่านั้น โปรดอย่าส่งให้เพื่อนหลายคน',
    viaMobileNumber: 'เบอร์มือถือ',
    viaMobileNumberDesc: 'กลับไปที่เบอร์มือถือ',
    viaSNS: 'ส่งของขวัญให้กลุ่ม',
    viaSNSDesc: 'สร้างลิงค์การแชร์',
    mobileShareConfirm:
      'ส่งต่อ “{coupon}” ไปยังเบอร์มือถือ {mobile} หรือไม่ โปรดทราบว่าคุณจะไม่สามารถใช้บัตรกำนัลได้หลังจากที่ส่งไปแล้ว',
    shareTextCopied: 'คัดลอกข้อความแล้ว!',
    line: 'LINE',
    messenger: 'Messenger',
    copy: 'คัดลอก',
    sms: 'ส่ง SMS',
    other: 'แบ่งปันอื่นๆ',
    amount: 'กรุณากรอกจำนวนใบที่ต้องการใช้',
    amountPlaceholder: '1 ใบ',
    shareHistory: 'บันทึกการโอน',
    expiryClosest: 'วันหมดอายุ: เร็วสุดก่อน',
    expiryLatest: 'วันหมดอายุ: ช้าสุดก่อน',
    receiveClosest: 'วันที่ได้รับ: เร็วสุดก่อน',
    receiveLatest: 'วันที่ได้รับ: เร็วสุดก่อน',
  },
};

const brand = {
  en: {
    branch: 'Branch information',
    openTime: 'Open time',
    useLocation: 'Use store',
  },
  'zh-Hant': {
    branch: '分店資訊',
    openTime: '營業時間',
    useStore: '使用據點',
  },
  vi: {
    branch: 'Thông tin chi nhánh',
    openTime: 'Thời gian mở cửa',
    useStore: 'Cứ điểm sử dụng',
  },
  th: {
    branch: 'ข้อมูลสาขา',
    openTime: 'เวลาทำการ',
    useStore: 'สาขาที่ใช้',
  },
};

const profile = {
  en: {
    vip: 'VIP Program',
    history: 'VIP History',
    historyEmpty: 'No record',
    current: 'Current',
    dueDate: ', valid until',
    dueDateAppend: '',
    desc: 'Benefits & Offers',
    condition: 'Policy',
    expire: 'Valid period',
    upgrade: 'Upgrade',
    upgradeCondition: 'Upgrade terms',
    upgradeProgress: 'Upgrade progress',
    downloadApp: 'Download Ocard APP',
    downloadTitle: 'Check all of your VIP cards and coupons!',
    download: 'Download',
    profile: 'Profile',
    mobile: 'Mobile number',
    editProfile: 'Edit Ocard profile',
    serial: 'Serial number',
  },
  'zh-Hant': {
    vip: '店家 VIP',
    history: 'VIP 歷史',
    historyEmpty: '尚無紀錄',
    current: '已持有',
    dueDate: '，將於',
    dueDateAppend: '到期',
    desc: '優惠內容',
    condition: '加入條件',
    expire: '到期資訊',
    upgrade: '升級資訊',
    upgradeCondition: '升級條件',
    upgradeProgress: '升級進度',
    downloadApp: '下載 Ocard APP',
    downloadTitle: '輕鬆查看所有品牌會員卡及優惠！',
    download: '前往',
    profile: '會員資訊',
    mobile: '會員手機號碼',
    editProfile: '修改 Ocard 個人檔案',
    serial: '實體卡號',
  },
  vi: {
    vip: 'VIP cửa hàng',
    history: 'Lịch sử VIP',
    historyEmpty: 'Không có ghi chép',
    current: 'Đã có',
    dueDate: ', sẽ hết hạn vào',
    dueDateAppend: '',
    desc: 'Nội dung ưu đãi',
    condition: 'Điều kiện gia nhập',
    expire: 'Thông tin hết hạn',
    upgrade: 'Thông tin nâng cấp',
    upgradeCondition: 'Điều kiện nâng cấp',
    upgradeProgress: 'Tiến độ nâng cấp',
    downloadApp: 'Tải Ocard APP về',
    downloadTitle: 'Truy cập dễ dàng mọi thẻ hội viên và ưu đãi!',
    download: 'Tải về',
    profile: 'Thông tin hội viên',
    mobile: 'Số điện thoại',
    editProfile: 'Sửa đổi thư mục cá nhân Ocard',
    serial: 'Số thẻ',
  },
  th: {
    vip: 'VIP ร้านค้า',
    history: 'ประวัติ VIP',
    historyEmpty: 'ยังไม่มีบันทึก',
    current: 'ถือครองอยู่แล้ว',
    dueDate: 'จะหมดอายุ',
    dueDateAppend: 'วุฒิภาวะ',
    desc: 'เนื้อหาส่วนลด',
    condition: 'เงื่อนไขการเข้าร่วม',
    expire: 'ข้อมูลการหมดอายุ',
    upgrade: 'อัพเกรดข้อมูล',
    upgradeCondition: 'เงื่อนไขการอัพเกรด',
    upgradeProgress: 'ความคืบหน้าการอัพเกรด',
    downloadApp: 'ดาวน์โหลด Ocard APP',
    downloadTitle: 'ดูบัตรสมาชิกและส่วนลดของแบรนด์ทั้งหมดได้อย่างง่ายดาย!',
    download: 'ไปที่',
    profile: 'ข้อมูลสมาชิก',
    mobile: 'เบอร์มือถือสมาชิก',
    editProfile: 'แก้ไขโปรไฟล์ Ocard',
    serial: 'หมายเลขบัตร',
  },
};

const edit = {
  en: {
    title: 'Ocard Profile',
    desc: 'This profile will sync to your other E-cards on Ocard',
    facebook: entry.en.profile.facebook,
    fbFailed: entry.en.login.fbFailed,
    name: entry.en.profile.name,
    gender: entry.en.profile.gender,
    male: entry.en.profile.male,
    female: entry.en.profile.female,
    birthday: entry.en.profile.birthday,
    pick: entry.en.profile.pick,
    yearFormat: entry.en.profile.yearFormat,
    monthFormat: entry.en.profile.monthFormat,
    dayFormat: entry.en.profile.dayFormat,
    nameEmpty: entry.en.profile.nameEmpty,
    genderEmpty: entry.en.profile.genderEmpty,
    birthdayEmpty: entry.en.profile.birthdayEmpty,
    success: 'Updated successfully',
    error: 'Update failed, please try again',
    terms: entry.en.common.termsWithData,
    termsWithData: entry.en.common.termsWithData,
  },
  'zh-Hant': {
    title: 'Ocard 個人檔案',
    desc: '您填寫的個人資訊將同步更新您的其他 Ocard 電子會員',
    facebook: entry['zh-Hant'].profile.facebook,
    fbFailed: entry['zh-Hant'].login.fbFailed,
    name: entry['zh-Hant'].profile.name,
    gender: entry['zh-Hant'].profile.gender,
    male: entry['zh-Hant'].profile.male,
    female: entry['zh-Hant'].profile.female,
    birthday: entry['zh-Hant'].profile.birthday,
    pick: entry['zh-Hant'].profile.pick,
    yearFormat: entry['zh-Hant'].profile.yearFormat,
    monthFormat: entry['zh-Hant'].profile.monthFormat,
    dayFormat: entry['zh-Hant'].profile.dayFormat,
    nameEmpty: entry['zh-Hant'].profile.nameEmpty,
    genderEmpty: entry['zh-Hant'].profile.genderEmpty,
    birthdayEmpty: entry['zh-Hant'].profile.birthdayEmpty,
    success: '已成功更新 Ocard 個人檔案',
    error: '發生錯誤，請重試',
    terms: entry['zh-Hant'].common.termsWithData,
    termsWithData: entry['zh-Hant'].common.termsWithData,
  },
  vi: {
    title: 'Thư mục cá nhân Ocard',
    desc: 'Thông tin bạn điền sẽ đồng bộ cập nhật hội viên điện tử Ocard khác của bạn',
    facebook: entry.vi.profile.facebook,
    fbFailed: entry.vi.login.fbFailed,
    name: entry.vi.profile.name,
    gender: entry.vi.profile.gender,
    male: entry.vi.profile.male,
    female: entry.vi.profile.female,
    birthday: entry.vi.profile.birthday,
    pick: entry.vi.profile.pick,
    yearFormat: entry.vi.profile.yearFormat,
    monthFormat: entry.vi.profile.monthFormat,
    dayFormat: entry.vi.profile.dayFormat,
    nameEmpty: entry.vi.profile.nameEmpty,
    genderEmpty: entry.vi.profile.genderEmpty,
    birthdayEmpty: entry.vi.profile.birthdayEmpty,
    success: 'Đã cập nhật thành cong thư mục cá nhân Ocard',
    error: 'Phát sinh lỗi, vui lòng thử lại',
    terms: entry.vi.common.termsWithData,
    termsWithData: entry.vi.common.termsWithData,
  },
  th: {
    title: 'โปรไฟล์ส่วนตัวของ Ocard',
    desc: 'ข้อมูลส่วนบุคคลที่คุณกรอกจะได้รับการอัปเดตพร้อมกันกับสมาชิก Ocard คนอื่น ๆ',
    facebook: entry['zh-Hant'].profile.facebook,
    fbFailed: entry['zh-Hant'].login.fbFailed,
    name: entry['zh-Hant'].profile.name,
    gender: entry['zh-Hant'].profile.gender,
    male: entry['zh-Hant'].profile.male,
    female: entry['zh-Hant'].profile.female,
    birthday: entry['zh-Hant'].profile.birthday,
    pick: entry['zh-Hant'].profile.pick,
    yearFormat: entry['zh-Hant'].profile.yearFormat,
    monthFormat: entry['zh-Hant'].profile.monthFormat,
    dayFormat: entry['zh-Hant'].profile.dayFormat,
    nameEmpty: entry['zh-Hant'].profile.nameEmpty,
    genderEmpty: entry['zh-Hant'].profile.genderEmpty,
    birthdayEmpty: entry['zh-Hant'].profile.birthdayEmpty,
    success: 'อัปเดตโปรไฟล์ Ocard สำเร็จแล้ว',
    error: 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',
    terms: entry['zh-Hant'].common.termsWithData,
    termsWithData: entry['zh-Hant'].common.termsWithData,
  },
};

const datepicker = {
  en: {
    selectYear: 'Choose a year',
    selectMonth: 'Choose a month',
    selectDate: 'Choose a date',
    invalid: 'Invalid date format',
    manualInput: 'Manual input',
  },
  'zh-Hant': {
    selectYear: '請選擇年份',
    selectMonth: '請選擇月份',
    selectDate: '使用日曆選擇',
    invalid: '不正確的日期格式',
    manualInput: '手動輸入',
  },
  vi: {
    selectYear: 'Vui lòng chọn năm',
    selectMonth: 'Vui lòng chọn tháng',
    selectDate: 'Chọn lịch',
    invalid: 'Định dạng ngày không chính xác',
    manualInput: 'Nhập bằng tay',
  },
  th: {
    selectYear: 'กรุณาเลือกปี',
    selectMonth: 'กรุณาเลือกเดือน',
    selectDate: 'ใช้การเลือกวันที่',
    invalid: 'รูปแบบวันที่ไม่ถูกต้อง',
    manualInput: 'กรอกเอง',
  },
};

const picker = {
  en: {
    select: 'Please choose one',
    selectMultiple: 'Please choose one or more',
  },
  'zh-Hant': {
    select: '請選擇',
    selectMultiple: '請選擇',
  },
  vi: {
    select: 'Vui lòng chọn',
    selectMultiple: 'Vui lòng chọn',
  },
  th: {
    select: 'กรุณาเลือก',
    selectMultiple: 'กรุณาเลือก',
  },
};

const draw = {
  en: {
    greatPrizes: 'Great prizes',
    startPlay: 'Start',
    acceptingOfTerms: 'By continuing, you give us permission to Ocard\'s <a href="https://ocard.co/en/privacy" target="_blank">privacy policy</a> and agree with Ocard\'s <a href="https://ocard.co/en/terms" target="_blank">terms and conditions</a>.',
    serial: 'Serial',
    choosePrize: 'Choose one to reveal the prize!',
    start: 'Start',
    stop: 'REVEAL',
    congratulation: 'You win a prize!',
    fillInYourMobileNumber: 'Mobile Number',
    clickStop: 'Click to reveal the prize!',
    shotDesc: 'Give it a shot!',
    startGame: 'Click “Start” to reveal the prize!',
    go: 'Go',
    fillInformation: 'Please fill in the information.',
    fillInformationByPrize: 'Please fill in the information for send you the prize.',
    reminderDesc: 'Reminder: Providing false information may result in the loss of offers.',
    acceptedOfTerms: 'You gave us permission to Ocard\'s <a href="/en/privacy" target="_blank">privacy policy</a> and agree with Ocard\'s <a href="/en/terms" target="_blank">terms and conditions</a>.',
    played: 'The result has been revealed.',
    sorry: 'Sorry…',
    sorryDesc: 'No luck this time',
    thankyou: 'Thank you',
  },
  'zh-Hant': {
    greatPrizes: '豐富獎品',
    startPlay: '開始遊玩',
    acceptingOfTerms: '開始遊玩即代表你同意 Ocard 的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>',
    serial: '序號',
    choosePrize: '點按任意一格遊玩抽大獎，快試試手氣吧！',
    start: '開始',
    stop: '停止',
    congratulation: '恭喜抽中',
    fillInYourMobileNumber: '輸入手機號碼',
    clickStop: '點按停止遊玩抽大獎',
    shotDesc: '快試試手氣吧！',
    startGame: '點按「開始」遊玩抽大獎',
    go: '前往',
    fillInformation: '請填寫您的個人資料',
    fillInformationByPrize: '請填寫您的個人資料，「{prize}」將存入您的手機號碼',
    reminderDesc: '提醒您，填寫不實可能導致優惠無法使用',
    acceptedOfTerms: '你已同意 Ocard 的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>',
    played: '你已經遊玩過囉！',
    sorry: '很遺憾',
    sorryDesc: '什麼都沒抽中',
    thankyou: '銘謝惠顧',
  },
  vi: {
    greatPrizes: 'Giải thưởng phong phú',
    startPlay: 'Bắt đầu chơi',
    acceptingOfTerms: 'Khi bắt đầu chơi có nghĩa là bạn đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard.',
    serial: 'Thứ tự',
    choosePrize: 'Nhấp vào bất kỳ ô nào để chơi và bốc thăm giải thưởng lớn, hãy thử vận ​​​​may nào!',
    start: 'Bắt đầu',
    stop: 'Dừng',
    congratulation: 'Chúc mừng bốc trúng',
    fillInYourMobileNumber: 'Nhập số máy di động',
    clickStop: 'Nhấp dừng bốc thắm trúng thưởng',
    shotDesc: 'Mau thử vận may nào!',
    startGame: 'Nhấp “Bắt đầu” chơi bốc thăm trúng thưởng',
    go: 'Vào',
    fillInformation: 'Vui lòng điền thông tin các nhân của bạn',
    fillInformationByPrize: 'Vui lòng điền thông tin cá nhân của bạn, “{prize}” sẽ gửi vào số máy di động của bạn.',
    reminderDesc: 'Xin nhắc, nếu điền sai thì không thể sử dụng ưu đãi.',
    acceptedOfTerms: 'Bạn đã đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard.',
    played: 'Bạn đã chơi rồi!',
    sorry: 'Rất tiếc...',
    sorryDesc: 'Chưa đến lúc trúng',
    thankyou: 'Xin cảm ơn!',
  },
  th: {
    greatPrizes: 'รางวัลมากมาย',
    startPlay: 'เริ่มเล่น',
    acceptingOfTerms: 'เมื่อเริ่มเล่น แสดงว่าคุณยอมรับ <a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>และ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a>',
    serial: 'เลขซีเรียล',
    choosePrize: 'คลิกที่ช่องใดก็ได้เพื่อเล่นและจับรางวัลใหญ่ ลองเสี่ยงโชคดูสิ!',
    start: 'เริ่ม',
    stop: 'หยุด',
    congratulation: 'ขอแสดงความยินดีด้วยค่ะ',
    fillInYourMobileNumber: 'กรอกเบอร์มือถือ',
    clickStop: 'คลิกเพื่อหยุดและจับรางวัล',
    shotDesc: 'ลองเสี่ยงโชคดูซิ!',
    startGame: 'คลิก “เริ่ม“ เพื่อเล่นและจับรางวัล',
    go: 'ไปที่',
    fillInformation: 'กรุณากรอกข้อมูลส่วนตัวของคุณ',
    fillInformationByPrize: 'กรุณากรอกข้อมูลส่วนบุคคลของคุณและ “{prize}” จะถูกเก็บไว้ในเบอร์มือถือของคุณ',
    reminderDesc: 'โปรดทราบว่าการกรอกไม่ถูกต้องอาจส่งผลให้ไม่สามารถใช้ส่วนลดได้',
    acceptedOfTerms: 'คุณได้ยอมรับ <a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>และ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a>',
    played: 'คุณเคยเล่นแล้ว',
    sorry: 'น่าเสียดายจัง',
    sorryDesc: 'ครั้งนี้โชคไม่ดีเลย',
    thankyou: 'ขอบคุณสำหรับการสนับสนุน',
  },
};

const transactions = {
  en: {
    transactions: 'Transactions',
    // eslint-disable-next-line no-template-curly-in-string
    spend: 'Spent ${spend}',
    empty: 'No record',
    purchaseLogged: 'Purchase logged',
  },
  'zh-Hant': {
    transactions: '交易紀錄',
    spend: '消費 {spend} 元',
    empty: '尚無紀錄',
    purchaseLogged: '已登錄消費',
  },
  vi: {
    transactions: 'Ghi chép giao dịch',
    spend: 'Thanh toán {spend} tệ',
    empty: 'Không có ghi chép',
    purchaseLogged: 'Đơn mua đã được ghi nhận',
  },
  th: {
    transactions: 'ประวัติการทำธุรกรรม',
    spend: 'ใช้ {spend} บาท',
    empty: 'ยังไม่มีบันทึก',
    purchaseLogged: 'บันทึกการสั่งซื้อเรียบร้อยแล้ว',
  },
};

const claim = {
  en: {
    claimDiscount: 'Claim discount',
    spent: 'Spent',
    pointRewards: 'Point rewards',
    points: 'Point | Point | Points',
    downloadOcard: 'Download Ocard',
    pointsRewarded: 'Points rewarded! Go to check',
    checkPoints: 'Check my points reward',
    loginClaim: 'Log in to claim',
    claimDesc: 'Claim as {user} {cell}',
    notMe: 'Not me',
    confirm: 'Confirm to claim',
    countryCode: 'Country code',
    phone: 'Phone number',
    collect: 'Collect',
    memberCenter: 'Go to member center',
    offerSerial: 'Offer serial number',
    eMembershipDesc: '{user} issues e-membership via Ocard.',
    personalDesc: 'Ocard does not share your personal information to any third party other than {name}.',
    acceptedOfTerms: 'By continuing, you agree to our privacy policy and terms of use.',
    successfullyDesc: 'Successfully claim {count} point! | Successfully claim {count} points!',
    claimPoints: 'Claim {point} point | Claim {point} points',
  },
  'zh-Hant': {
    claimDiscount: '領取優惠',
    spent: '消費金額',
    pointRewards: '品牌點數',
    points: '點',
    downloadOcard: '下載 Ocard',
    pointsRewarded: '點數已領取！前往查看',
    checkPoints: '前往查看我的點數',
    loginClaim: '登入領取',
    claimDesc: '使用{user} {cell} 的身份領取',
    notMe: '這不是我',
    confirm: '確認領取',
    countryCode: '國碼',
    phone: '手機號碼',
    collect: '領取',
    memberCenter: '前往會員中心',
    offerSerial: '優惠序號',
    eMembershipDesc: '「{user}」透過 Ocard 發行電子會員。',
    personalDesc: 'Ocard 不會將你的個人資料提供給除了「{name}」以外任何第三方單位；',
    acceptedOfTerms: '領取即代表你同意我們的<a href="/privacy" target="_blank">隱私權政策</a>及<a href="/terms" target="_blank">使用者條款</a>',
    successfullyDesc: '成功領取了{count}點！',
    claimPoints: '領取 {point} 點點數',
  },
  vi: {
    claimDiscount: 'Lĩnh nhận ưu đãi',
    spent: 'Số tiền chi tiêu',
    pointRewards: 'Số điểm hãng',
    points: 'điểm',
    downloadOcard: 'Tải Ocard về',
    pointsRewarded: 'Đã lĩnh nhận số điểm! Vào xem',
    checkPoints: 'Vào xem số điểm của tôi',
    loginClaim: 'Đăng nhập lĩnh nhận',
    claimDesc: 'Sử dụng danh tính của {user} {cell} để lĩnh nhận',
    notMe: 'Không phải là tôi',
    confirm: 'Xác nhận lĩnh nhận',
    countryCode: 'Mã quốc gia',
    phone: 'Số điện thoại',
    collect: 'Lĩnh nhận',
    memberCenter: 'Vào Trung tâm Hội viên',
    offerSerial: 'Thứ tứ ưu đãi',
    eMembershipDesc: '“{user}” thông qua Ocard phát hành hội viên điện tử.',
    personalDesc: 'Ocard không cung cấp thông tin cá nhân của bạn cho bất cứ đơn vị thứ ba nào ngoài “{name}”;',
    acceptedOfTerms: 'Lĩnh nhận có nghĩa là bạn đồng ý với <a href="/vi/privacy" target="_blank">chính sách quyền riêng tư</a> và <a href="/vi/terms" target="_blank">điều khoản người dùng</a> của Ocard.',
    successfullyDesc: 'Đã lĩnh nhận thành công {count} điểm!',
    claimPoints: 'Lĩnh nhận số điểm của {point} điểm',
  },
  th: {
    claimDiscount: 'รับส่วนลด',
    spent: 'ยอดที่ใช้',
    pointRewards: 'คะแนนแบรนด์',
    points: 'คะแนน',
    downloadOcard: 'ดาวน์โหลด Ocard',
    pointsRewarded: 'สะสมคะแนนแล้ว! เข้าไปดูเลย',
    checkPoints: 'ไปดูคะแนนของฉัน',
    loginClaim: 'เข้าสู่ระบบเพื่อรับ',
    claimDesc: 'ใช้ {user} {cell} เพื่อรับ',
    notMe: 'นี่ไม่ใช่ฉัน',
    confirm: 'ยืนยันการรับ',
    countryCode: 'รหัสประเทศ',
    phone: 'เบอร์มือถือ',
    collect: 'รับ',
    memberCenter: 'ไปที่ศูนย์สมาชิก',
    offerSerial: 'เลขซีเรียลส่วนลด',
    eMembershipDesc: '“{user}” ออก e-membership ผ่าน Ocard',
    personalDesc: 'Ocard จะไม่ให้ข้อมูลส่วนบุคคลของคุณแก่บุคคลที่สาม ยกเว้น “{name}”;',
    acceptedOfTerms: 'เมื่อรับ <a href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>และ<a href="/terms" target="_blank">ข้อกำหนดการใช้งานของ Ocard</a>',
    successfullyDesc: 'รับ {count} คะแนนสำเร็จ!',
    claimPoints: 'รับ {point} คะแนน',
  },
};

const trialCoupon = {
  en: {
    validDays: 'Valid for {day} days',
    validFromTomorrow: 'Valid from tomorrow',
    details: 'Details',
    branches: 'Branches',
    claimed: 'Claimed',
    totalAndRemaining: 'Total pcs: {total}. Remaining pcs: {remaining}.',
    claim: 'Claim',
  },
  'zh-Hant': {
    validDays: '可用效期 {day} 天',
    validFromTomorrow: '限領取後翌日使用',
    details: '嚐鮮券詳情',
    branches: '適用據點',
    claimed: '已領取',
    totalAndRemaining: '限量 {total} 組・剩餘 {remaining} 組',
    claim: '領取嚐鮮券',
  },
  vi: {
    validDays: 'Thời hạn có thể dùng {day} ngày',
    validFromTomorrow: 'Có hiệu lực vào ngày hôm sau sau khi lĩnh nhận',
    details: 'Xem chi tiết',
    branches: 'Cứ điểm áp dụng',
    claimed: 'Đã lĩnh nhận',
    totalAndRemaining: 'Giới hạn {total} nhóm. Còn lại {remaining} nhóm',
    claim: 'Lĩnh nhận phiếu thử mới',
  },
  th: {
    validDays: 'ระยะเวลาที่ใช้ได้ {day} วัน',
    validFromTomorrow: 'สามารถใช้ได้ในวันถัดไปหลังการสะสมเท่านั้น',
    details: 'รายละเอียดคูปอง',
    branches: 'สาขาที่ใช้ได้',
    claimed: 'รับแล้ว',
    totalAndRemaining: 'จำกัด {total} ชุด・เหลือ {remaining} ชุด',
    claim: 'รับคูปอง',
  },
};

const pointStock = {
  en: {
    title: 'Point rewards sotck',
    filters: 'Filters',
    allCities: '',
    allBranches: '',
    allRewards: '',
    currentStock: '',
    reward: 'Reward',
    branch: 'Branch',
    quantity: 'Remaing',
    emptyData: '',
    desc: '',
    unit: 'pc | pc | pcs',
  },
  'zh-Hant': {
    title: '電子集點兌換庫存',
    filters: '篩選',
    allCities: '全部縣市',
    allBranches: '全部分店據點',
    allRewards: '全部兌換項目',
    currentStock: '現有庫存',
    reward: '兌換項目',
    branch: '分店據點',
    quantity: '剩餘數量',
    emptyData: '尚無紀錄',
    desc: '本頁面顯示之剩餘數量，僅供參考；實際數量請洽各分店據點',
    unit: '份',
  },
  vi: {
    filterCondition: '',
    selectCity: '',
    selectStore: '',
    selectProduct: '',
    currentStock: '',
    productName: '',
    storeLocation: '',
    stockQuantity: '',
    noData: '',
    stockDesc: '',
  },
  th: {
    filterCondition: '',
    selectCity: '',
    selectStore: '',
    selectProduct: '',
    currentStock: '',
    productName: '',
    storeLocation: '',
    stockQuantity: '',
    noData: '',
    stockDesc: '',
  },
};

const gifts = {
  en: {
    giftInbox: 'Gift inbox',
    luckyDraw: 'Lucky draw',
    luckyPick: 'Lucky pick',
    luckySwapper: 'Lucky swapper',
    luckySpin: 'Lucky spin',
    questionnaire: 'Questionnaire',
    unused: 'New',
    used: 'Finished',
  },
  'zh-Hant': {
    giftInbox: '禮物盒',
    luckyDraw: '行動刮刮卡',
    luckyPick: '四選一',
    luckySwapper: '快選',
    luckySpin: '轉盤',
    questionnaire: '行動智慧問卷',
    unused: '未參加',
    used: '已參加',
  },
  vi: {
    giftInbox: 'Hộp quà',
    luckyDraw: 'Thẻ cào may mắn',
    luckyPick: 'Chọn 1 trong 4',
    luckySwapper: 'Chọn nhanh',
    luckySpin: 'Vòng quay may mắn',
    questionnaire: 'Bản khảo sát thông minh',
    unused: 'Chưa tham gia',
    used: 'Đã tham gia',
  },
  th: {
    giftInbox: 'กล่องของขวัญ',
    luckyDraw: 'บัตรขูดลุ้นโชค',
    luckyPick: 'เลือก 1 จาก 4',
    luckySwapper: 'เลือกเร็ว',
    luckySpin: 'วงล้อเสี่ยงโชค',
    questionnaire: 'แบบสอบถามอัจฉริยะ',
    unused: 'ยังไม่ได้เข้าร่วม',
    used: 'เข้าร่วมแล้ว',
  },
};

export default {
  en: {
    common: common.en,
    entry: entry.en,
    index: index.en,
    barcode: barcode.en,
    ultrasound: ultrasound.en,
    tab: tab.en,
    points: points.en,
    coupons: coupons.en,
    reward: reward.en,
    brand: brand.en,
    profile: profile.en,
    edit: edit.en,
    datepicker: datepicker.en,
    picker: picker.en,
    draw: draw.en,
    transactions: transactions.en,
    claim: claim.en,
    trialCoupon: trialCoupon.en,
    pointStock: pointStock.en,
    gifts: gifts.en,
  },
  'zh-Hant': {
    common: common['zh-Hant'],
    entry: entry['zh-Hant'],
    index: index['zh-Hant'],
    barcode: barcode['zh-Hant'],
    ultrasound: ultrasound['zh-Hant'],
    tab: tab['zh-Hant'],
    points: points['zh-Hant'],
    coupons: coupons['zh-Hant'],
    reward: reward['zh-Hant'],
    brand: brand['zh-Hant'],
    profile: profile['zh-Hant'],
    edit: edit['zh-Hant'],
    datepicker: datepicker['zh-Hant'],
    picker: picker['zh-Hant'],
    draw: draw['zh-Hant'],
    transactions: transactions['zh-Hant'],
    claim: claim['zh-Hant'],
    trialCoupon: trialCoupon['zh-Hant'],
    pointStock: pointStock['zh-Hant'],
    gifts: gifts['zh-Hant'],
  },
  vi: {
    common: common.vi,
    entry: entry.vi,
    index: index.vi,
    barcode: barcode.vi,
    ultrasound: ultrasound.vi,
    tab: tab.vi,
    points: points.vi,
    coupons: coupons.vi,
    reward: reward.vi,
    brand: brand.vi,
    profile: profile.vi,
    edit: edit.vi,
    datepicker: datepicker.vi,
    picker: picker.vi,
    draw: draw.vi,
    transactions: transactions.vi,
    claim: claim.vi,
    trialCoupon: trialCoupon.vi,
    pointStock: pointStock.vi,
    gifts: gifts.vi,
  },
  th: {
    common: common.th,
    entry: entry.th,
    index: index.th,
    barcode: barcode.th,
    ultrasound: ultrasound.th,
    tab: tab.th,
    points: points.th,
    coupons: coupons.th,
    reward: reward.th,
    brand: brand.th,
    profile: profile.th,
    edit: edit.th,
    datepicker: datepicker.th,
    picker: picker.th,
    draw: draw.th,
    transactions: transactions.th,
    claim: claim.th,
    trialCoupon: trialCoupon.th,
    pointStock: pointStock.th,
    gifts: gifts.th,
  },
};
